/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comments/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import Content from './Content/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Comments({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/CommentsLogs/Comments",
  closePopover
  
}) {
  let isBefore = useIsBefore()
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Comments.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-ZCPene': dtColorsNeutral200,'--bc-2-ZCPene': dtColorsWhite,'--btlr-3-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-8-ZCPene': isBefore ? 0 : 1,'--ty-9-ZCPene': isBefore ? "-8px" : "0px"}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Comments.Vertical:1"
  data-view-path={viewPath}
 closePopover={closePopover}
 className="views-block"
>
<div
  data-testid="Comments.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-10-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-11-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-12-ZCPene': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Comments"
 weight="semibold"
 color={dtColorsNeutral500}
/>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}